import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';
import { RECENCY_PERIODS } from '#/utils/constants/general/recency';

export function recencyFacet(i18n: I18nFn) {
  return {
    id: 'recencyFacet',
    name: 'recency',
    get title() {
      return i18n('Date Posted');
    },
    type: 'string',
    options: Object.keys(RECENCY_PERIODS(i18n)),
    optionTitles: RECENCY_PERIODS(i18n),
  } as const satisfies SearchFacetData;
}
